import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { SortTableIcon } from '~/assets/icons';
import { memo, useState } from 'react';
import { HeadCelType, SortDirection, SortField } from '~/utils/types/common';
import MenuSortDirection from './menu-sort-direction/MenuSortDirection';

type BaseTableHeadProps = {
  numSelected: number;
  onRequestSort: (property: string, sortDirection: SortDirection) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowCount: number;
  headCells: Array<HeadCelType>;
  sort?: Array<SortField>;
};

const BaseTableHead = (props: BaseTableHeadProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [selectedProperty, setSelectedProperty] = useState<string | null>(null);

  const { onSelectAllClick, numSelected, rowCount, onRequestSort, headCells }: BaseTableHeadProps = props;

  const openSortDirectionMenu = (property: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setSelectedProperty(property);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const createSortHandler = (sortDirection: SortDirection) => {
    if (selectedProperty) {
      onRequestSort(selectedProperty, sortDirection);
    }
    handleClose();
  };

  const renderActiveSort = () => {
    return props?.sort?.find((item) => item.field === selectedProperty)?.type;
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding='checkbox'>
          <Checkbox
            className='w-[20px] h-[20px]'
            color='primary'
            indeterminate={false}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id as string}
            align={'left'}
            padding={index === headCells.length - 1 ? 'none' : 'normal'}
          >
            <TableSortLabel
              IconComponent={() => headCell.sortable && <SortTableIcon className='ml-[32px] w-[19px] h-[19px]' />}
              onClick={headCell.sortable ? openSortDirectionMenu(headCell.id) : undefined}
            >
              {headCell.label ?? headCell.id}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
      <MenuSortDirection
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        active={renderActiveSort()}
        onSelectAscDirection={() => createSortHandler('ASC')}
        onSelectDescDirection={() => createSortHandler('DESC')}
      />
    </TableHead>
  );
};

export default memo(BaseTableHead);
